// Access token: in-memory only.
// Storing it outside JS-readable storage (localStorage/sessionStorage) blocks XSS-persistent
// theft. The token is short-lived (≈60s) so losing it on reload is fine — the HttpOnly refresh
// cookie under /api/auth lets us mint a new one transparently.
let _accessToken = null;

const normalizeToken = (value) => {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmedValue = value.trim();
  if (!trimmedValue || trimmedValue === 'undefined' || trimmedValue === 'null') {
    return null;
  }

  return trimmedValue;
};

export const getAccessToken = () => _accessToken;

export const setAccessToken = (token) => {
  _accessToken = normalizeToken(token);
};

// Refresh token lives in an HttpOnly cookie (set by the backend on /api/auth/login,
// /api/auth/refresh, /api/auth/google/callback, /api/auth/google/token). It is never
// readable from JS — the browser sends it automatically on requests under /api/auth.
// These no-op shims exist for legacy call sites that still call setTokens(...).
export const setTokens = (accessToken /* , refreshToken (ignored) */) => {
  setAccessToken(accessToken);
};

export const clearTokens = () => {
  _accessToken = null;
  // Clear any tokens left from previous storage-based flows.
  try {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    sessionStorage.removeItem('refreshToken');
  } catch (_) { /* ignore */ }
};
